import _extends from "@babel/runtime-corejs3/helpers/extends";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat";
import { createCommentVNode as _$ccv, createUnknownComponentVNode as _$cc, className as _$cn, createElementVNode as _$ce, createTextVNode as _$ct, createVNode as _$cv, map as _$ma } from 'intact-vue';
import { getRestProps, mapChildren } from '../utils';
import { ButtonGroup, Button } from '../button';
import { Select, Option } from '../select';
import { Input } from '../input';
import { Icon } from '../icon';
import { _$ } from '../../i18n';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    total = _this$get.total,
    size = _this$get.size,
    flat = _flatInstanceProperty(_this$get),
    simple = _this$get.simple,
    className = _this$get.className,
    showTotal = _this$get.showTotal,
    showGoto = _this$get.showGoto,
    counts = _this$get.counts,
    value = _this$get.value,
    limit = _this$get.limit,
    limits = _this$get.limits,
    showLimits = _this$get.showLimits,
    disableBtn = _this$get.disableBtn,
    disablePage = _this$get.disablePage;
  if (!total) return _$ccv(' pagination ');
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-pagination"] = true, _classNameObj[className] = className, _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[k + "-flat"] = flat, _classNameObj[k + "-simple"] = simple, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var type = flat ? 'flat' : simple ? 'none' : 'default';
  var totalPages = Math.ceil(total / limit) || 0;
  var paginationButton = function paginationButton(page) {
    var disabled = false;
    if (page !== value) {
      if (disablePage) {
        disabled || (disabled = !!disablePage(page, limit));
      }
      if (disableBtn) {
        disabled || (disabled = !!disableBtn(page, limit));
      }
    }
    return _$cc(Button, {
      'type': type,
      'size': size,
      'icon': true,
      'value': page,
      'disabled': disabled,
      'children': page
    });
  };
  var paginationDot = function paginationDot(callback) {
    return _$cc(Button, {
      'type': type,
      'size': size,
      'icon': true,
      'className': _$cn(k + "-pagination-ellipsis"),
      'ev-click': callback,
      'children': '...'
    });
  };
  var paginationItems = [];
  var minCount = Math.ceil(counts / 2);
  var maxCount = totalPages - minCount;
  var prevPage = value - 1;
  var nextPage = value + 1;
  if (!simple) {
    if (totalPages > counts) {
      if (value <= minCount) {
        var max = counts - 2;
        for (var i = 1; i <= max; i++) {
          paginationItems.push(paginationButton(i));
        }
        paginationItems.push(paginationDot(this.fastNext));
        paginationItems.push(paginationButton(totalPages));
      } else if (value > minCount && value <= maxCount) {
        paginationItems.push(paginationButton(1));
        paginationItems.push(paginationDot(this.fastPrev));
        var midCount = counts - 4;
        var mid = Math.floor(midCount / 2);
        var min = value - mid;
        var _max = midCount % 2 === 1 ? value + mid : value + mid - 1;
        for (var _i = min; _i <= _max; _i++) {
          paginationItems.push(paginationButton(_i));
        }
        paginationItems.push(paginationDot(this.fastNext));
        paginationItems.push(paginationButton(totalPages));
      } else {
        paginationItems.push(paginationButton(1));
        paginationItems.push(paginationDot(this.fastPrev));
        var _min = totalPages - counts + 3;
        for (var _i2 = _min; _i2 <= totalPages; _i2++) {
          paginationItems.push(paginationButton(_i2));
        }
      }
    } else {
      for (var _i3 = 1; _i3 <= totalPages; _i3++) {
        paginationItems.push(paginationButton(_i3));
      }
    }
  } else {
    paginationItems = [_$cc(Input, {
      'size': size === 'mini' || size === 'small' ? 'mini' : 'small',
      'autoWidth': true,
      'value': value,
      'ev-change': this.goto
    }), _$ce(2, 'span', [_$ct(' / '), totalPages], 0, _$cn(k + "-pagination-text"))];
  }
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), [showTotal && !simple ? _$ce(2, 'div', _$('共 {n} 条', {
    n: total
  }), 0, _$cn(k + "-pagination-total")) : undefined, _$cc(ButtonGroup, {
    'checkType': 'radio',
    'children': [_$cc(Button, {
      'icon': true,
      'size': size,
      'type': 'none',
      'disabled': value <= 1 || !!(disablePage && disablePage(value - 1, limit)),
      'ev-click': this.prev,
      'children': _$cc(Icon, {
        'className': _$cn(k + "-icon-left")
      })
    }), paginationItems, _$cc(Button, {
      'icon': true,
      'size': size,
      'type': 'none',
      'disabled': value >= totalPages || !!(disablePage && disablePage(value + 1, limit)),
      'ev-click': this.next,
      'children': _$cc(Icon, {
        'className': _$cn(k + "-icon-right")
      })
    })],
    'ev-$model:value': function ev$modelValue($v) {
      $this.set('value', $v);
    },
    'value': $this.get('value')
  }), !simple ? [showLimits ? _$ce(2, 'div', _$cc(Select, {
    'size': size,
    'flat': flat,
    'children': _$ma(limits, function ($value, $key) {
      return _$cc(Option, {
        'value': $value,
        'children': _$('{n} 条 / 页', {
          n: $value
        })
      });
    }, $this),
    'ev-$model:value': function ev$modelValue($v) {
      $this.set('limit', $v);
    },
    'value': $this.get('limit')
  }), 2, _$cn(k + "-pagination-limits")) : undefined, showGoto ? _$ce(2, 'div', [_$ce(2, 'span', _$('前往'), 0, 'c-middle'), _$cc(Input, {
    'size': size,
    'value': value,
    'ev-change': this.goto,
    'flat': flat
  }), _$ce(2, 'span', _$('页'), 0, 'c-middle')], 4, _$cn(k + "-pagination-goto")) : undefined] : undefined]);
}
;